import CreateReceptionPage from "../pages/reception/create-reception-page.vue";
import ReceptionListPage from "../pages/reception/reception-list-page.vue";
import ReceptionDetailPage from "../pages/reception/reception-detail-page.vue";
import { AppScope } from "@/utils/app-scope";
import { AttributeGroupType } from "@/interfaces/attributes/attribute";
import ImportReceptionCsvPage from "@/pages/reception/import-reception-csv-page.vue";
import ImportOrderCsvPage from "@/pages/reception/import-order-csv-page.vue";
import ReceptionStatusPage from "@/pages/reception/reception-status-page.vue";

const receptionRoutes = [
  {
    path: "/reception/create",
    name: "create-reception",
    component: CreateReceptionPage,
    meta: {
      titleKey: "reception.create_page_title",
      access: 2,
      scope: AppScope.reception,
    },
  },
  {
    path: "/reception/status/:reception_id",
    name: "reception-status",
    component: ReceptionStatusPage,
    meta: {
      access: 100,
      scope: AppScope.reception,
    },
  },
  {
    path: "/reception/modify/:reception_id",
    name: "modify-reception",
    component: CreateReceptionPage,
    meta: {
      withoutTitle: true,
      withoutTitleRefresh: true,
      withoutBreadcrumb: true,
      withoutBreadcrumbRefresh: true,
      access: 2,
      scope: AppScope.reception,
    },
  },
  {
    path: "/reception/list",
    alias: "/reception",
    name: "reception-list",
    component: ReceptionListPage,
    meta: {
      access: 1,
    },
  },
  {
    path: "/reception/detail/:reception_id",
    name: "reception-detail",
    component: ReceptionDetailPage,
    meta: {
      withoutTitle: true,
      withoutTitleRefresh: true,
      withoutBreadcrumb: true,
      withoutBreadcrumbRefresh: true,
      access: 1,
      scope: AppScope.reception,
    },
  },
  {
    path: "/reception/import",
    name: "import-receptions",
    component: ImportReceptionCsvPage,
    props: {
      dataLabel: "reception.title",
      attributeGroup: AttributeGroupType.receptionImport,
      report: true
    },
    meta: {
      title: "Importer des attendus receptions",
      access: 10,
    },
  },
  {
    path: "/order/import",
    name: "import-orders",
    component: ImportOrderCsvPage,
    props: {
      dataLabel: "order.title",
      attributeGroup: AttributeGroupType.orderImport,
      report: true
    },
    meta: {
      title: "Importer des commandes",
      access: 10,
    },
  },
];

export default receptionRoutes;
